/* Naht & Leinen – Produktseite (Team B1): Versandbalken, Galerie-Punkte (mobil), Sparset-Link je Verschluss,
   „Bewertung schreiben“, Video-Dialog. Nutzt die Craft-Ereignisse aus pubsub.js (cartUpdate, variantChange). */
(function () {
  'use strict';

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function geld(cent) {
    var betrag = (Math.max(0, cent) / 100).toFixed(2).replace('.', ',');
    return betrag.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  }

  function esc(text) {
    var d = document.createElement('div');
    d.textContent = text;
    return d.innerHTML;
  }

  /* ---------- Versandbalken ---------- */
  var korbStand = null;

  function versandZeichnen(korb) {
    korbStand = korb || korbStand;
    if (!korbStand) return;
    document.querySelectorAll('[data-nl-versand]').forEach(function (el) {
      var schwelle = parseInt(el.dataset.schwelle, 10) || 5000;
      var variante = String(el.dataset.variante || '');
      var preis = parseInt(el.dataset.preis, 10) || 0;
      var summe = korbStand.total_price || 0;
      var imKorb = (korbStand.items || []).some(function (i) { return String(i.variant_id) === variante; });
      if (el.dataset.mitrechnen === 'true' && !imKorb && el.dataset.verfuegbar !== 'false') summe += preis;
      var rest = schwelle - summe;
      var prozent = Math.min(100, Math.round((summe * 100) / schwelle));
      var text = el.querySelector('[data-nl-versand-text]');
      var balken = el.querySelector('[data-nl-versand-balken]');
      if (text) {
        if (rest > 0) {
          text.innerHTML = esc(el.dataset.textRest || '').replace('[betrag]', '<strong>' + geld(rest) + '</strong>');
        } else {
          text.textContent = el.dataset.textFrei || '';
        }
      }
      el.classList.toggle('is-frei', rest <= 0);
      if (balken) balken.style.width = prozent + '%';
      var leiste = el.querySelector('[role="progressbar"]');
      if (leiste) leiste.setAttribute('aria-valuenow', String(prozent));
    });
  }

  function korbLaden() {
    if (!document.querySelector('[data-nl-versand]')) return;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(versandZeichnen)
      .catch(function () {});
  }

  /* ---------- Sparset-Link je Verschluss ---------- */
  function sparsetAktualisieren(variante) {
    if (!variante || !variante.options) return;
    document.querySelectorAll('[data-nl-sparset]').forEach(function (karte) {
      var daten;
      try { daten = JSON.parse(karte.getAttribute('data-nl-sparset')); } catch (e) { return; }
      var treffer = null;
      variante.options.forEach(function (wert) { if (daten[wert]) treffer = daten[wert]; });
      if (!treffer) return;
      karte.querySelectorAll('[data-nl-sparset-link]').forEach(function (a) { a.href = treffer.url; });
      var preis = karte.querySelector('[data-nl-sparset-preis]');
      var alt = karte.querySelector('[data-nl-sparset-alt]');
      var spar = karte.querySelector('[data-nl-sparset-spar]');
      if (preis) preis.textContent = geld(treffer.preis);
      if (alt) alt.textContent = treffer.alt > treffer.preis ? geld(treffer.alt) : '';
      if (spar) {
        spar.hidden = !(treffer.alt > treffer.preis);
        spar.textContent = (spar.dataset.vorlage || 'Du sparst [betrag]').replace('[betrag]', geld(treffer.alt - treffer.preis));
      }
    });
  }

  /* ---------- Variantenwechsel ---------- */
  function variantenWechsel(ereignis) {
    var v = ereignis && ereignis.data && ereignis.data.variant;
    if (!v) return;
    document.querySelectorAll('[data-nl-versand]').forEach(function (el) {
      el.dataset.variante = v.id;
      el.dataset.preis = v.price;
      el.dataset.verfuegbar = v.available ? 'true' : 'false';
    });
    versandZeichnen();
    sparsetAktualisieren(v);
  }

  /* ---------- Galerie: Punkte unter dem Hauptbild (mobil) ---------- */
  function galeriePunkte(galerie) {
    var viewer = galerie.querySelector('slider-component[id^="GalleryViewer"]');
    if (!viewer || viewer.querySelector('.nl-pdp-punkte')) return;
    var liste = viewer.querySelector('.product__media-list');
    var knoepfe = viewer.querySelector('.slider-buttons');
    if (!liste || !knoepfe) return;
    var folien = liste.querySelectorAll('.product__media-item');
    if (folien.length < 2 || folien.length > 9) return;
    var punkte = document.createElement('div');
    punkte.className = 'nl-pdp-punkte';
    punkte.setAttribute('role', 'group');
    punkte.setAttribute('aria-label', 'Bild auswählen');
    Array.prototype.forEach.call(folien, function (folie, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Bild ' + (i + 1) + ' von ' + folien.length);
      if (i === 0) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () {
        var ziel = liste.querySelectorAll('.product__media-item')[i];
        if (ziel) liste.scrollTo({ left: ziel.offsetLeft - liste.offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
      });
      punkte.appendChild(b);
    });
    knoepfe.insertBefore(punkte, knoepfe.firstChild);
    viewer.addEventListener('slideChanged', function (e) {
      var nr = e.detail && e.detail.currentPage ? e.detail.currentPage - 1 : 0;
      punkte.querySelectorAll('button').forEach(function (b, i) {
        if (i === nr) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    });
    galerie.classList.add('nl-pdp-mit-punkten');
  }

  /* ---------- „Bewertung schreiben“ öffnet das Judge.me-Formular ---------- */
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-nl-bewerten]');
    if (!knopf) return;
    var jdgm = document.querySelector('.jdgm-write-rev-link');
    var widget = document.getElementById('judgeme_product_reviews');
    if (jdgm) {
      e.preventDefault();
      jdgm.click();
      (widget || jdgm).scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });
    }
  });

  /* ---------- Video-Dialog ---------- */
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-nl-video-dialog]');
    if (!knopf) return;
    var dialog = document.getElementById(knopf.getAttribute('data-nl-video-dialog'));
    if (!dialog || typeof dialog.showModal !== 'function') return;
    e.preventDefault();
    var vorlage = dialog.querySelector('template');
    var ziel = dialog.querySelector('.nl-pdp-dialog__medien');
    if (vorlage && ziel && !ziel.firstElementChild) ziel.appendChild(vorlage.content.cloneNode(true));
    dialog.showModal();
    var video = ziel && ziel.querySelector('video');
    if (video) { try { video.play(); } catch (err) {} }
    dialog.addEventListener('close', function zu() {
      if (ziel) ziel.innerHTML = '';
      knopf.focus();
      dialog.removeEventListener('close', zu);
    });
  });
  /* Text-Link unter der Video-Karte startet das Video im Vorschaubild */
  document.addEventListener('click', function (e) {
    var start = e.target.closest('[data-nl-video-start]');
    if (!start) return;
    var poster = document.getElementById(start.getAttribute('data-nl-video-start'));
    if (poster) {
      poster.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'center' });
      poster.click();
    }
  });

  document.addEventListener('click', function (e) {
    var zu = e.target.closest('[data-nl-dialog-zu]');
    if (zu) { var d = zu.closest('dialog'); if (d) d.close(); return; }
    if (e.target.classList && e.target.classList.contains('nl-pdp-dialog')) e.target.close();
  });

  /* Kürzerer Knopftext: auch nach Variantenwechsel (product-info.js setzt window.variantStrings.addToCart) */
  function knopfText() {
    var zeile = document.querySelector('.nl-pdp-kaufzeile[data-nl-knopftext]');
    if (!zeile || !window.variantStrings) return;
    var neu = zeile.getAttribute('data-nl-knopftext');
    var alt = window.variantStrings.addToCart;
    if (!neu || alt === neu) return;
    window.variantStrings.addToCart = neu;
    var span = zeile.querySelector('.product-form__submit > span');
    if (span && span.textContent.trim() === alt) span.textContent = neu;
  }

  function start() {
    knopfText();
    korbLaden();
    document.querySelectorAll('.nl-pdp media-gallery').forEach(galeriePunkte);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ereignis) {
        if (ereignis && ereignis.cartData && typeof ereignis.cartData.total_price === 'number' && ereignis.cartData.items) {
          versandZeichnen(ereignis.cartData);
        } else {
          korbLaden();
        }
      });
      subscribe(PUB_SUB_EVENTS.variantChange, variantenWechsel);
    }
    /* Warenkorb-Schublade ändert Mengen: danach neu rechnen */
    document.addEventListener('cart:updated', korbLaden);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { start(); });
})();
